<template>
  <BubbleChart
    :request-status="requestStatus"
    :title="title"
    :item-id="itemId"
    :series="series"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BubbleChart from '@/components/cards/models/BubbleChart';
import { mapActions } from 'vuex';
import resolversPerformanceMatrix from '@/components/cards/resolvers/resolversPerformanceMatrix';

export default {
  name: 'PerformanceByTimeMatrix',
  components: {
    BubbleChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: 'performanceByTime',
    },
  },
  data() {
    return {
      rawSeries: {},
      requestStatus: 'loading',
    };
  },
  computed: {
    cardOptions() {
      const getTooltipHTML = (point) => this.resolver.getTooltipHTML(point);
      return {
        tooltip: {
          useHTML: true,
          formatter() {
            return getTooltipHTML(this.point);
          },
          followPointer: false,
          style: {
            pointerEvents: 'auto',
          },
        },
        xAxis: {
          categories: this.generateHourCategories(),
          title: {
            text: this.$t('components.PerformanceByTimeMatrix.label.xAxis.title'),
          },
        },
        yAxis: {
          gridLineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false,
          },
          title: {
            text: this.$t('components.PerformanceByTimeMatrix.label.yAxis.title'),
          },
        },
      };
    },
    resolver() {
      return resolversPerformanceMatrix[this.type];
    },
    series() {
      return this.resolver.series(this.rawSeries);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getPerformanceService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getPerformanceService({
        itemId: this.itemId,
        servicePath: 'performanceByTyme',
        serviceParams: {
          filter: this.filter,
        },
      })
        .then(response => {
          this.rawSeries = response;
          this.requestStatus = 'success';
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    generateHourCategories() {
      const hours = [];
      for (let i = 0; i < 24; i++) {
        const hour = i.toString().padStart(2, '0');
        hours.push(`${hour}:00`);
      }
      return hours;
    },
  },
};
</script>
